export default __webpack_public_path__ + "static/badminton-sec1-img-86cb27ff5b73eebc5cd20f5f989702fc.png";